import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    body {
        box-sizing: border-box;
        font-family: GmarketSansMedium;
    }`;

export default GlobalStyle;
